<template>
  <div>
    <div class="element-container">
      <ElementActions
        @remove="$emit('removeElement')"
      />
      <Editor
        :key="`content-${content.id}`"
        :content="content.value"
        :type="type"
        @change="v => $emit('change', v)"
      />
    </div>
    <AddElement
      @addElement="$emit('addElement')"
    />
  </div>
</template>

<script>
  import Editor from './editor/Editor';
  import AddElement from './AddElement';
  import ElementActions from './Actions';

  export default {
    props: ['content', 'displayFirstAdd', 'type'],
    components: {
      Editor,
      AddElement,
      ElementActions,
    }
  };
</script>

<style>
  .element-container {
    background: #ffffff;
    position: relative;
    border: 1px dotted #eee;
    padding: 30px 10px 0 10px;
    margin-top: 10px;
    transition: 0.3s;
    border-radius: 3px;
  }

  .element-container:hover {
    background: #e1eaf5;
    transition: 0.3s;
  }
</style>
